import { Status, StatusTransitions } from '../types';

export function isStatusTransitionValid(fromStatus: Status, toStatus: Status): boolean {
  const possibleToStatuses = (StatusTransitions[fromStatus] ?? []) as Status[];

  return possibleToStatuses.includes(toStatus);
}
